import { type Fight } from 'src/types'

export const fights: Fight[] = [
  {
    logs: [
      {
        author: '',
        text: 'You stand before a tired and lonesome tortoise.',
        omen: 'bad'
      }
    ],
    victoryEffects: {},
    lvl: 2,
    defeatEffects: {},
    spareEffects: {},
    createdAt: 1679179825809,
    lootEffects: {},
    id: 'tortoise_lvl_2',
    npcId: 'tortoise',
    killEffects: {},
    isVerified: true
  },
  {
    logs: [
      {
        author: 'ludwig',
        text: 'Kaka-poops!',
        omen: 'special'
      }
    ],
    victoryEffects: {},
    lvl: 1,
    defeatEffects: {},
    spareEffects: {},
    createdAt: 1679232237963,
    lootEffects: {},
    id: 'ludwig_lvl_1',
    npcId: 'ludwig',
    killEffects: {},
    isVerified: false
  },
  {
    logs: [
      {
        author: '',
        text: 'You were ambushed by a black bear.',
        omen: 'bad'
      }
    ],
    victoryEffects: {},
    lvl: 2,
    defeatEffects: {},
    spareEffects: {},
    createdAt: 1679139183077,
    lootEffects: {},
    id: 'bear_lvl_2',
    npcId: 'bear',
    killEffects: {},
    isVerified: true
  },
  {
    logs: [
      {
        author: 'Taxman',
        text: 'You should have filled the e30 form.\nNow you must face the power of the IRS!',
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        }
      }
    },
    lvl: 1,
    defeatEffects: {
      switches: {
        gameover: true
      },
      counters: {
        defeats: {
          '+': 1
        }
      }
    },
    spareEffects: {
      counters: {
        karma: {
          '+': 10
        }
      }
    },
    createdAt: 1679139198112,
    lootEffects: {
      counters: {
        cash: {
          '+': 1
        }
      }
    },
    id: 'taxman_lvl_1',
    npcId: 'taxman',
    killEffects: {},
    isVerified: false
  },
  {
    logs: [
      {
        author: 'pedobear',
        text: 'Hmm juicy...',
        omen: 'special'
      }
    ],
    victoryEffects: {
      fight: 'fight'
    },
    lvl: 1,
    defeatEffects: {},
    spareEffects: {},
    createdAt: 1679667355414,
    lootEffects: {
      items: {
        fur: {
          '+': 1
        }
      }
    },
    id: 'bear_lvl_1',
    npcId: 'bear',
    killEffects: {},
    isVerified: false
  },
  {
    logs: [
      {
        author: 'thug',
        text: "You're gonna regret this.",
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 5
        }
      }
    },
    lvl: 3,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 5
        }
      }
    },
    createdAt: 1679179844266,
    lootEffects: {
      counters: {
        player_cash: {
          '+': 5
        }
      },
      items: {
        knife: {
          '+': 1
        }
      }
    },
    id: 'thug_lvl_3',
    npcId: 'thug',
    killEffects: {
      counters: {
        player_karma: {
          '-': 50
        }
      }
    },
    isVerified: false
  },
  {
    logs: [
      {
        author: '',
        text: 'You crossed paths with a wolf!',
        omen: 'bad'
      }
    ],
    victoryEffects: {},
    lvl: 1,
    defeatEffects: {},
    spareEffects: {},
    createdAt: 1679509325995,
    lootEffects: {},
    id: 'wolf_lvl_1',
    npcId: 'wolf',
    killEffects: {},
    isVerified: false
  },
  // === NEW MISSING FIGHTS === //
  {
    logs: [
      {
        author: 'wanderer',
        text: 'A mysterious wanderer blocks your path with ancient wisdom in their eyes.',
        omen: 'special'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 20
        },
        player_karma: {
          '+': 10
        }
      }
    },
    lvl: 20,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 25
        },
        player_lvl_exp: {
          '+': 10
        }
      }
    },
    createdAt: Date.now(),
    lootEffects: {
      counters: {
        player_cash: {
          '+': 50
        }
      }
    },
    id: 'wanderer_lvl_20',
    npcId: 'wanderer',
    killEffects: {
      counters: {
        player_karma: {
          '-': 100
        }
      }
    },
    isVerified: false
  },
  {
    logs: [
      {
        author: '',
        text: 'A pack of coyotes surrounds you, their eyes gleaming with hunger.',
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 12
        }
      }
    },
    lvl: 12,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 15
        }
      }
    },
    createdAt: Date.now(),
    lootEffects: {
      counters: {
        player_cash: {
          '+': 25
        }
      }
    },
    id: 'coyotes_lvl_12',
    npcId: 'coyotes',
    killEffects: {
      counters: {
        player_karma: {
          '-': 30
        }
      }
    },
    isVerified: false
  },
  {
    logs: [
      {
        author: '',
        text: 'The tortoise towers before you, get ready for a hard fight.',
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 8
        }
      }
    },
    lvl: 8,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 20
        }
      }
    },
    createdAt: Date.now(),
    lootEffects: {
      counters: {
        player_cash: {
          '+': 15
        }
      }
    },
    id: 'tortoise_lvl_8',
    npcId: 'tortoise',
    killEffects: {
      counters: {
        player_karma: {
          '-': 40
        }
      }
    },
    isVerified: false
  },
  {
    logs: [
      {
        author: '',
        text: 'A massive bear, scarred from countless battles, rises to challenge you.',
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 9
        }
      }
    },
    lvl: 9,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 15
        }
      }
    },
    createdAt: Date.now(),
    lootEffects: {
      counters: {
        player_cash: {
          '+': 20
        }
      }
    },
    id: 'bear_lvl_9',
    npcId: 'bear',
    killEffects: {
      counters: {
        player_karma: {
          '-': 45
        }
      }
    },
    isVerified: false
  },
  {
    logs: [
      {
        author: '',
        text: 'A seasoned wolf, battle-hardened and cunning, prepares to strike.',
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 5
        }
      }
    },
    lvl: 1,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 10
        }
      }
    },
    createdAt: Date.now(),
    lootEffects: {
      counters: {
        player_cash: {
          '+': 10
        }
      }
    },
    id: 'wolf_lvl_1',
    npcId: 'wolf',
    killEffects: {
      counters: {
        player_karma: {
          '-': 25
        }
      }
    },
    isVerified: false
  },
  {
    logs: [
      {
        author: 'thug',
        text: 'You picked the wrong fight, kid. Time to learn a lesson.',
        omen: 'bad'
      }
    ],
    victoryEffects: {
      counters: {
        player_victories: {
          '+': 1
        },
        player_lvl_exp: {
          '+': 7
        }
      }
    },
    lvl: 7,
    defeatEffects: {
      switches: {
        gameover: true
      }
    },
    spareEffects: {
      counters: {
        player_karma: {
          '+': 15
        }
      }
    },
    createdAt: Date.now(),
    lootEffects: {
      counters: {
        player_cash: {
          '+': 35
        }
      }
    },
    id: 'thug_lvl_7',
    npcId: 'thug',
    killEffects: {
      counters: {
        player_karma: {
          '-': 75
        }
      }
    },
    isVerified: false
  }
]

// Export removed - now using named export above
